import { Box, CardMedia, useTheme } from "@mui/material";
import TopBar from "./components/TopBar";
import menu_url from '@/assets/images/maps/menu.png'
import { DesktopProps } from "./types";

const DesktopMap = ({ sx, leftSideSx, displaySearch = true, topBarSx, children }: DesktopProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.white,
        padding: { xs: "5px", md: "10px" },
        width: "1056px",
        height: "700px",
        boxSizing: "border-box",
        borderRadius: '16px',
        boxShadow:
          '0px 2.5px 2px 0px rgba(0, 0, 0, 0.02), 0px 6px 5px 0px rgba(0, 0, 0, 0.03), 0px 11px 9px 0px rgba(0, 0, 0, 0.04), 0px 20px 16px 0px rgba(0, 0, 0, 0.04), 0px 38px 30px 0px rgba(0, 0, 0, 0.05)',
        display: "flex",
        ...sx
      }}
    >
      <CardMedia 
        component="img" 
        image={menu_url}
        alt="map" 
        sx={{
          height: "100%",
          ...leftSideSx
        }} 
      />
      <Box
        sx={{
          position: "relative",
          flex: "1 1 auto",
          overflow: "hidden",
          borderTopRightRadius: "12px",
          borderBottomRightRadius: "12px"
        }}
      >
        <TopBar displaySearch={displaySearch} sx={topBarSx} />
        {children}
      </Box>
    </Box>
  );
};

export default DesktopMap;